/** Join truthy class names into a single className string. */
export const cx = (...classes: (string | false | undefined)[]): string => classes.filter(Boolean).join(' ');
